export default "__VITE_ASSET__2512cdc3__"